export default __webpack_public_path__ + "static/media/ShantiLogo.41c02a6a.webp";